import hookFns from "./hookFns";

const defaultOptions = {
    width: '100%',
    altrows: true,
    sortable: true,
    pagesize: 20,
    filterable: true,
    height: screen.height >= 800 ? (window.innerHeight - 300) : 400,
    showfilterrow: true,
    columnsresize: true,
    columnsreorder: true,
    enablebrowserselection: true,
    columnsmenu: false,
    columns: [],
    showtoolbar: true,
    autoshowfiltericon: true,
    rendertoolbar: function (toolbar) {},
    rendergridrows: function (obj) {
        return obj.data;
    },
    ready: function () {}
};

export default function buildGrid($grid = $(), options = {}) {
    $grid.jqxGrid({...defaultOptions, ...options});

    return (options = {}, hooks = []) => {
        hookFns($grid, options)(hooks);
        return {$grid, options};
    }

}